/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

// React //
import { useState } from "react";
import { useHistory } from "react-router-dom";

// Hooks //
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { useMetaDescription } from "../../hooks/useMetaDescription";

// Components //
import ButtonDefault from "../../components/form/ButtonDefault";
import Checkbox from "../../components/form/InputCheckbox";
import InputDefault from "../../components/form/InputDefault";

// Icons //
import { 
    IconArrowLeft, 
    IconClosedEye, 
    IconEyeOpen, 
    IconFacebook, 
    IconInsta, 
    IconLinkedin, 
    IconLogoJuridico, 
    IconQuestion 
} from "../../components/icons";

// Services //
import api from "../../services/api";
import toast, { Toaster } from 'react-hot-toast';
import { toastDefs, toastDefsError } from '../../config/toastConfig';
import { useAuth } from "../../contexts/UserContext";

// Styles //
import { Container, Footer, Header, MainLeft, MainRight, MainWrapper } from "./styles";

// Assets //
import LoginImage from "../../assets/images/LoginImage.svg"
import LoginImageNew from "../../assets/images/jessicaMarques.svg"
import logoLegalOps from '../../assets/images/logoLegalOps.svg';
import loginHero from "../../assets/images/loginHero.jpg";
import LogoLegalOps from "../../components/LogoLegalOps";
import { comum } from "../../styles/Themes/light";

interface SignInProps {
    Email: string;
    Senha: any;
}

export default function Login() {
    const history = useHistory();
    const { signIn } = useAuth();
    
    // Define o título da página
    useDocumentTitle({ title: "Entrar" });
    
    // Define a meta description da página
    useMetaDescription({ 
        description: "Acesse sua conta na EasyJur Legal Ops. Faça login para gerenciar suas demandas jurídicas e operações legais de forma eficiente." 
    });

    const [loading, setLoading] = useState<boolean>(false)
    const [checked, setChecked] = useState<boolean>(false);
    const [login, setLogin] = useState<SignInProps>({
        Email: "",
        Senha: ""
    });
    const [ forgotPass, setForgotPass ] = useState<any>()
    const [ changeVisibility, setChangeVisibility ] = useState<boolean>(true);
    const [ forgotPassword, setForgotPassword ] = useState<boolean>(false);
    const [ emptyField, setEmptyField ] = useState<any>();
    const [ errorMessage, setErrorMessage ] = useState<any>();
    // const [remember, setRemember] = useState<boolean>(false)

    const onChangeLogin = (key: any, value: string) => {
        if (key === "Email") login.Email = value
        if (key === "Senha") login.Senha = value
        setLogin({ ...login })
    }

    // useEffect(() => {

    //     getRemember()

    // }, [])

    // function getRemember() {

    //     const dataRemember = window.localStorage.getItem('@Jj:remember')

    //     if (dataRemember) {

    //         const dataRememberJSON = JSON.parse(dataRemember)

    //         setLogin({
    //             Email: dataRememberJSON.Email,
    //             Senha: dataRememberJSON.Senha
    //         })
    //         setChecked(true)

    //         console.log('log confirmando que o user manteve logado', checked)
            
    //         history.push('/painel')

    //     } else {
    //         console.log('Decidiu não manter conectado')
    //     }
    // }

    async function handleSubmit(e: any) {
        e.preventDefault();

        try {            
            setLoading(true);
            if (!login.Email) {
                setEmptyField(true);
                setErrorMessage('Campo obrigatório')
                throw new Error ('Email é obrigatório');
            }
            if (!login.Senha) {
                setEmptyField(true)
                setErrorMessage('Campo obrigatório')
                throw new Error ('Senha é obrigatória')
            }

            await signIn({
                email: login.Email,
                senha: login.Senha
            })
            
            setLoading(false);            

        } catch (error: any) {

            setLoading(false)
            
            toast.error(error.message);

        }
    }

    async function submitForgotPassword(e: any) {
        e.preventDefault();

        try {
            setLoading(true);
            
            if (!forgotPass) {
                setEmptyField(true);
                setErrorMessage('Campo obrigatório');
                throw new Error('E-mail é obrigatório');
            }

            const response = await api.get('usuarios/senha/recuperar/' + forgotPass);

            if (response.data.status !== 'success') throw (response.data.message);

            setLoading(false);
            toast.success('Email enviado com sucesso.', toastDefs);
            
            setTimeout(() => {
                setForgotPassword(false);
            }, 1500)
            

        } catch (error: any) {
            setLoading(false) 
            // console.log('log do erro', error)
            toast.error(error.toString(), toastDefsError);
        }
    }

    return (
        <Container>
            
            <MainWrapper>
                <div className="header">
                    <div className="back"
                        onClick={() => window.location.href = 'https://easyjur.com/legal-operations/'}
                    >
                        <span><IconArrowLeft /></span> Voltar para o site
                    </div>
                </div>
                {
                    forgotPassword
                    ?
                        <MainLeft className="top-align">
                            <Header style={{marginBottom: '40px', height: 'auto'}}>
                                <LogoLegalOps forceVariant="white" width={150} style={{ height: "auto", marginBottom: 32 }} alt="Logo Legal Ops" />
                                <h1 className="forgot">Esqueci a senha</h1>
                                <p className="forgot-text">Informe seu e-mail e enviaremos um link para redefinir sua senha.</p>
                            </Header>

                            <form onSubmit={submitForgotPassword} className="forgot-form">
                                <InputDefault 
                                    title="E-mail"
                                    value={forgotPass}
                                    onChangeText={(value) => setForgotPass(value)}
                                    className={errorMessage && !forgotPass ? 'empty' : ''}
                                    error={errorMessage && !forgotPass ? errorMessage : ''}
                                />

                                <div className="buttons">
                                    <button
                                        onClick={() => setForgotPassword(false)}
                                    >
                                        Voltar ao login
                                    </button>

                                    <ButtonDefault>
                                        Enviar link
                                    </ButtonDefault>
                                </div>
                            </form>

                        </MainLeft>
                        
                    :
                        <MainLeft className="top-align">

                            <Header>
                                {/* <IconLogoJuridico /> */}
                                <LogoLegalOps forceVariant="white" width={150} style={{ height: "auto" }} alt="Logo Legal Ops" />

                                {/* <p>Participe da revolução na <span className="blueTitle">logística jurídica</span> com <span className="redTitle">Legal Ops!</span> </p> */}
                                <p>
                                    Bem vindo ao <span className="redTitle">EasyJur Legal Ops</span>!
                                </p>
                            </Header>

                            <form onSubmit={handleSubmit}>

                                <InputDefault
                                    title="E-mail:"
                                    value={login.Email}
                                    onChangeText={(value) => onChangeLogin('Email', value)}
                                    className={emptyField && !login.Email ? 'empty' : ''}
                                    error={errorMessage && !login.Email ? errorMessage : ''}
                                />

                                <div className="password">
                                    <InputDefault
                                        title="Senha:"
                                        type={changeVisibility ? 'password' : 'text'}
                                        value={login.Senha}
                                        onChangeText={(value) => onChangeLogin('Senha', value)}
                                        className={emptyField && !login.Senha ? 'empty' : ''}
                                        error={errorMessage && !login.Senha ? errorMessage : ''}
                                    />
                                    <div 
                                        className="icon"
                                        onClick={() => setChangeVisibility(!changeVisibility)}
                                    >
                                        {changeVisibility ? <IconEyeOpen /> : <IconClosedEye /> }
                                    </div>
                                </div>

                                {/* Talvez será removido essa função */}
                                <div className="checkbox">
                                    <Checkbox
                                        label="Manter conectado"
                                        name="Manter conectado"
                                        value={checked}
                                        onClick={() => setChecked(!checked)}
                                    />
                                </div>
                                {/* Talvez será removido essa função */}

                                <div className="field">
                                    <ButtonDefault loading={loading}>Acessar</ButtonDefault>
                                </div>

                            </form>

                            <Footer>
                                <button onClick={() => {setForgotPassword(true); setForgotPass(login.Email)}}>
                                   Esqueceu a senha?
                                </button>
                            </Footer>

                        </MainLeft>
                }

                <MainRight>
                   
                    {/* <img src={LoginImage} alt="Imagem da tela de login" /> */}
                    <div className="text-wrapper">
                        <p className="text-wrapper-title">A plataforma nº #1 em eficiência jurídica</p>
                        {/* <p className="text-wrapper-subtitle">Compromisso com a excelência jurídica em cada detalhe.</p> */}
                        <p className="text-wrapper-subtitle">Uma nova identidade, com a mesma missão de revolucionar a logística jurídica</p>
                    </div>
                    <img src={loginHero}  alt="Imagem da tela de login" />

                </MainRight>

            </MainWrapper>
            <Toaster />
        </Container>
    )
}